interface IAuth {
  trackingInsta?: any;
  uid?: string;
  posUid?: string;
  displayName?: string;
  fbUid?: string;
  fbName?: string;
  createdTime?: string;
  announcements?: string;
  role?: number;
  userType?: number;
  jwt?: string;
  settings?: any;
  business?: any;
  businesses?: any;
  // Các doanh nghiệp có quyền sử dụng
  mBids?: Array<any>;
  // Tất cả các doanh nghiệp liên quan (luôn lưu dưới dạng mảng)
  aBids?: Array<any>;
  bids?: string;
  // Tất cả các pages
  pageIds?: Array<any>;
  pages?: {
    [key: string]: {
      id?: any;
      businessId?: any;
      channel?: any;
      name?: string;
      avatar?: string;
      token?: string;
      isSyncedData?: any;
      settings?: any;
    }
  };
}

export const ROLES = {
  SuperAdmin: 1,
  Admin: 2,
  Business_Manager: 100,
  Page_Admin: 120,
  Business_Staff: 150,
  Blog_Editor: 152,
  Member: 200,
  Guest: 255
};

export const ROLES_NAME = {
  [ROLES.SuperAdmin]: 'Super Admin',
  [ROLES.Admin]: 'Admin',
  [ROLES.Business_Manager]: 'Giám đốc doanh nghiệp',
  [ROLES.Page_Admin]: 'Admin page',
  [ROLES.Business_Staff]: 'Nhân viên trực page',
  [ROLES.Blog_Editor]: 'Nhân viên quản lý blog',
  [ROLES.Member]: 'Nhân viên',
  [ROLES.Guest]: 'Khách',
};

export interface IUserHeader {
  type: string,
  picture: string,
  displayName: string,
  fb: {
    picture: string,
    displayName: string,
  },
  userType?: number
}


export interface UserAccessSettings {
  status: number;
  sh: number; // start hour
  sm: number; // start minute
  eh: number; // end hour
  em: number; // end minute
}

export interface IUserBusiness {
  id: string;
  userId: string;
  businessId: string;
  role: number;
  /** roleId dạng string (VD: 'SYSTEM_ROLE_STAFF') — dùng cho filter quyền mới */
  roleId?: string | number;
  /** Tên role hiển thị */
  roleName?: string;
  /** Mảng permission key — ['*'] = full, hoặc ['conversation', ...] */
  permissions?: string[];
  settings: {
    timeAllowedAccess: UserAccessSettings;
  };
  lastAccessTime1: number;
  lastAccessTime2: number;
  createdTime: number;
  updatedLog: any; // or null, or a specific interface if you know its structure
  userDisplayName: string;
  userDisplayNamePos: string;
  locked: number;
  mobile: string;
  email: string;
  fbUid: string;
  /** URL ảnh đại diện (cloud) */
  avatar?: string;
  joinConversationAt: string;
  lastActiveAt: string;
  /** Tên hiển thị bổ sung (từ POS, Nhanh.vn, ...) */
  displayName?: string;
  /** Tên từ Facebook */
  fbName?: string;
  /** Danh sách page được phân quyền */
  pages?: Array<{ id: string; name?: string; channel?: number; avatar?: string }>;
}


export const userModel = {
  locked: {
    LOCKED: 1, // Khóa
    UNLOCKED: 2, // Mở Khóa
    DISABLED: 3, // Vô hiệu hóa (xóa) tài khoản
  },
  getRoleName(role: number) {
    return ROLES_NAME[role]
  }
}
